// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const ErrorIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "Error/outline"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M4 12a8 8 0 1 1 16 0 8 8 0 0 1-16 0Zm8-10C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm1 7a1 1 0 0 0-2 0v2a1 1 0 1 0 2 0V9Zm-1 5a1 1 0 1 0 0 2h.01a1 1 0 0 0 0-2H12Z",
  clipRule: "evenodd"
}));
export default ErrorIcon;